import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";

function PaletteViewer() {
  const theme = useTheme();
  console.log("theme----->>>", theme);
  return (
    <div>
      <h2>Palette Colors</h2>
      <div style={{ display: "flex", flexWrap: "wrap" }}>
        {Object.entries(theme.palette).map(([key, value]) => (
          <div key={key} style={{ margin: "10px", textAlign: "center" }}>
            <h3>{key}</h3>
            {Object.entries(value).map(([shadeKey, shadeValue]) => (
              <div key={shadeKey}>
                <Box
                  sx={{
                    width: "50px",
                    height: "50px",
                    backgroundColor: shadeValue,
                    borderRadius: "50%",
                    border: (theme) => `1px solid ${theme.palette.text.primary}`,
                    margin: "auto",
                  }}
                />
                <div>
                  {shadeKey}: {shadeValue}
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

export default PaletteViewer;
